import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const EsccValidateModalUI = ({ context, successMsg, errorList, setErrorList,
    updateMode, submitted, onSubmit, onCancelClick, accountName
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Validate ESCC account'
    buttonLabel='Confirm'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <div className='g_muted'>
      Are you sure you wish to validate {accountName} as per ICICI's response?
    </div>
  </ModalFormUI>

export default EsccValidateModalUI